import { SECONDS_PER_HOUR } from "@/constants/time.constants";

export const timePortion = (totalSeconds: number) => {
  const hours = Math.floor(totalSeconds / SECONDS_PER_HOUR);
  let minutes = (totalSeconds % SECONDS_PER_HOUR) / 60; // We need the exact number of minutes to calc the seconds
  const seconds = Math.floor((minutes * 60) % 60);
  minutes = Math.floor(minutes);

  const s = seconds ? `${seconds}s` : "";
  const minSec = minutes ? `${minutes}min ${s}` : s;

  const res = hours ? `${hours}h ${minSec}` : minSec;
  return res.trim();
};
